import { Fragment, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { ValidationErrorMessage } from "../../Layout/Common/alert/validationErrorMessage";
import { base64Decode, base64Encode, getLoginReturnUrl } from "../../Layout/Common/common";
import Cookies from "universal-cookie";
import LoaderButton from "../../Layout/Common/loaderButton";
import { useFlashLoaderLoader } from "../../Context/FlashScreenContext";
import { debounce } from "lodash";

export const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [Hdf, setHdf] = useState("");
  const [hdfToken, setHdfToken] = useState("");
  const { logoutReset } = useGlobalFunction();
  const [errorMessage, SetErrorMessage] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const histroy = useNavigate();
  const { isAuthenticated, loginfunction, checkAuthentication } = useAuth();
  const { search, location } = useLocation();
  const cookies = new Cookies();
  const loginError = JSON.parse(process.env.REACT_APP_LoginError);
  const [showPassword, setShowPassword] = useState(false);
  const { showLoader, hideLoader } = useFlashLoaderLoader();
  const debouncedRef = useRef(null);

  if (debouncedRef.current === null) {
    debouncedRef.current = debounce(() => {
      if (process.env.REACT_APP_ENV == 1 || true) {
        checkAuthentication();
      }
    }, 2000);
  }

  useEffect(() => {
    localStorage.setItem("previousOrderModal", false);
  }, []);

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState !== "visible") return;
      debouncedRef.current();
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      debouncedRef.current.cancel();
    };
  }, []);

  useEffect(() => {
    if (search) {
      const errcode = base64Decode(search.substring(1));
      const errorInfo = loginError[errcode];
      if (errorInfo) {
        SetErrorMessage(errorInfo);
      }
      const savedUsername = cookies.get("username");
      const savedPassword = cookies.get("password");
      const savedRememberMe = cookies.get("rememberMe") == true;
      if (savedRememberMe && savedUsername && savedPassword) {
        setUsername(base64Decode(savedUsername));
        setPassword(base64Decode(savedPassword));
        setRememberMe(true);
      }
    } else {
      SetErrorMessage("");
    }
  }, [search]);
  useEffect(() => {
    if (isAuthenticated == false) {
      logoutReset();
      localStorage.setItem("checkPreviousOrderPopup", false);
      localStorage.setItem("checkOverDuePopup", false);
    }
  }, [isAuthenticated]);

  const handleClientClick = (e) => {
    SetErrorMessage("");

    const expirationDate = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);
    if (username == "") {
      SetErrorMessage("Please fill the User Name");
      e.preventDefault();
      return false;
    } else if (password == "") {
      SetErrorMessage("Please fill the Password");
      e.preventDefault();
      return false;
    }
    showLoader();
    SetErrorMessage("");
  };

  return (
    <div className="loginModal-body">
      <form action={window.location.origin + "/api/Authenticate/CheckLogin"} method="POST">
        <div className="row">
          <div className="col-md-12">
            <div className="floating-input floatingEmail-input mb-3">
              <input
                type="text"
                className="form-control form-input"
                id="username"
                name="username"
                autoComplete="off"
                maxLength="50"
                placeholder=""
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
              />
              <label htmlFor="emailid">Email</label>
            </div>
          </div>
          <div className="col-md-12">
            <div className="floating-input loginChangedPwd mb-3">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control  form-input"
                autoComplete="off"
                id="password"
                name="password"
                maxLength="32"
                placeholder=""
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <label htmlFor="changePwd1">Password</label>
              <span
                className={showPassword ? "loginPassword wes-eye" : "loginPassword wes-eye-slash"}
                onClick={() => setShowPassword(!showPassword)}
              ></span>
            </div>
          </div>
          <div className="col-md-12">
            <ValidationErrorMessage
              message={errorMessage}
              handleHidden={() => {
                SetErrorMessage("");
              }}
              title="Login-In Failed"
            />
            <div className="button-effect">
              <button type="submit" className="btn btn-products btn-addcart" onClick={handleClientClick}>
                Login
              </button>
              {/*<a href="../index.html" className="btn btn-products btn-addcart"> Login</a>*/}
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <div className="loginRemember-forgot loginRemember-border">
              <div className="row">
                <div className="col-md-12 col-lg-12 col-xl-5">
                  <div className="form-check custom-check loginRemember">
                    <div className="signature-req-input">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={true}
                        id="rememberme"
                        name="rememberme"
                      />
                    </div>
                    <label className="form-check-label" htmlFor="rememberMe">
                      Remember Me
                    </label>
                  </div>
                </div>
                <div className="col-md-12 col-lg-8 col-xl-7">
                  <ul className="loginForgot mt-2 mt-xl-0">
                    <li>Forgot</li>
                    <li>
                      <Link to="/Forgotusername"> Username</Link>
                    </li>
                    <li>or</li>
                    <li>
                      <Link to="/Forgotpassword"> Password?</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <input
          type="hidden"
          className="form-control form-input"
          value={window.location.pathname}
          name="cUrl"
          id="cUrl"
        />
        <input
          type="hidden"
          className="form-control form-input"
          value={
            String(window.location.pathname).toLowerCase().includes("/login")
              ? getLoginReturnUrl() || window.location.pathname
              : window.location.pathname
          }
          name="hdfUrl"
          id="hdfUrl"
        />
      </form>
    </div>
  );
};
